const pageNameKey = "transferButton";

export const transferButtonEn = {
  [pageNameKey]: {
    tooltip: "Transfer selected data objects to new structure",
    transferTextCountPlaceholder: "{count}",
    transferTextNoItems: "Transfer",
    transferTextSingularTemplate: "Transfer {count} item",
    transferTextPluralTemplate: "Transfer {count} items",
  },
};

export const transferButtonPtBr = {
  [pageNameKey]: {
    tooltip: "Transferir objetos de dados selecionados para a nova estrutura",
    transferTextCountPlaceholder: "{count}",
    transferTextNoItems: "Transferir",
    transferTextSingularTemplate: "Transferir {count} item",
    transferTextPluralTemplate: "Transferir {count} itens",
  },
};

export const transferButtonDe = {
  [pageNameKey]: {
    tooltip: "Übertrage ausgewählter Datenobjekte in die neue Struktur",
    transferTextCountPlaceholder: "{count}",
    transferTextNoItems: "Transfer",
    transferTextSingularTemplate: "Übertrage {count} Element",
    transferTextPluralTemplate: "Übertrage {count} Elemente",
  },
};

export const transferButtonZhHans = {
  [pageNameKey]: {
    tooltip: "将选定的数据对象传输到新结构",
    transferTextCountPlaceholder: "{count}",
    transferTextNoItems: "传输",
    transferTextSingularTemplate: "传输 {count} 个项目",
    transferTextPluralTemplate: "传输 {count} 个项目",
  },
};

export const transferButtonIt = {
  [pageNameKey]: {
    tooltip:
      "Trasferisci gli oggetti di dati selezionati nella nuova struttura",
    transferTextCountPlaceholder: "{count}",
    transferTextNoItems: "Trasferimento",
    transferTextSingularTemplate: "Trasferisci {count} elemento",
    transferTextPluralTemplate: "Trasferisci {count} elementi",
  },
};

export const transferButtonEs = {
  [pageNameKey]: {
    tooltip:
      "Transferir los objetos de datos seleccionados a una nueva estructura",
    transferTextCountPlaceholder: "{count}",
    transferTextNoItems: "Transferir",
    transferTextSingularTemplate: "Transferir elemento {count}",
    transferTextPluralTemplate: "Transferir {count} elementos",
  },
};

export const transferButtonNl = {
  [pageNameKey]: {
    tooltip: "Geselecteerde gegevensobjecten overdragen naar nieuwe structuur",
    transferTextCountPlaceholder: "{count}",
    transferTextNoItems: "Overdragen",
    transferTextPluralTemplate: "Draag {count} items over",
    transferTextSingularTemplate: "Draag {count} item over",
  },
};

export const transferButtonTr = {
  [pageNameKey]: {
    tooltip: "Seçili veri nesnelerini yeni yapıya aktar",
    transferTextCountPlaceholder: "{count}",
    transferTextNoItems: "Aktarım",
    transferTextPluralTemplate: "{count} öğelerini aktar",
    transferTextSingularTemplate: "{count} öğesini aktar",
  },
};
